import { shop } from '@/commonTypes';
import styles from '../styles.module.css';
import React from 'react';
import ShopAddress from '../ShopAddress';
import PageCard from '@/components/general/PageCard';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import MainIcons from '@/icons/main';
import { blogBg } from '@/functions/formats';
import AppLink from '@/components/common/AppLink';
import NearByStore from '@/components/pages/product/ProductsContent/ShopsMap/NearByStores/NearByStore';

export default function ShopSideInfo({ shop }: { shop?: shop }) {
  const similarCloseShops = Array.from({ length: 3 }, (_, index) => ({
    ...shop,
    id: index + 1,
    randomNumber: Math.floor(Math.random() * 360),
    count: index,
  }));
  return (
    <div className={`${styles.side}`}>
      <div className={`card`}>
        <ShopAddress shop={shop} />
      </div>
      <PageCard noIconWidth={true} title="فروشگاه‌های مشابه نزدیک">
        <div className={`${styles.similarCloseShopList}`}>
          {similarCloseShops?.map((item, index) => (
            <NearByStore
              store={item}
              key={index}
              index={index}
              className={`${styles.similarCloseShopItem}`}
              activeFillColor={`var(--danger)`}
              titleClass={`${styles.titleClass}`}
            />
          ))}
        </div>
      </PageCard>
    </div>
  );
}
